var PCSPHP_TRANSLATIONS_DE = {
	lang: {
		'es': 'Spanisch',
		'en': 'Englisch',
		'fr': 'Französisch',
		'de': 'Deutsch',
		'it': 'Italienisch',
		'pt': 'Portugiesisch',
	},
	langShort: {
		'es': 'ES',
		'en': 'EN',
		'fr': 'FR',
		'de': 'DE',
		'it': 'IT',
		'pt': 'PT',
	},
	titles: {
		error: 'Fehler',
		success: 'Erfolg',
		created: 'Erstellt',
		edited: 'Bearbeitet',
	},
	errors: {
		pass_not_match: 'Fehler: Die Passwörter müssen übereinstimmen.',
		unexpected_error: 'Ein unerwarteter Fehler ist aufgetreten.',
		unexpected_error_try_later: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
		name_is_required: 'Der Vorname ist erforderlich.',
		name_should_be_string: 'Der Vorname muss eine Zeichenkette sein.',
		lastname_is_required: 'Der Nachname ist erforderlich.',
		lastname_should_be_string: 'Der Nachname muss eine Zeichenkette sein.',
		email_is_required: 'Die E-Mail ist erforderlich.',
		email_should_be_string: 'Die E-Mail muss eine Zeichenkette sein.',
		user_is_required: 'Der Benutzername ist erforderlich.',
		user_should_be_string: 'Der Benutzername muss eine Zeichenkette sein.',
		password_is_required: 'Das Passwort ist erforderlich.',
		password_should_be_string: 'Das Passwort muss eine Zeichenkette sein.',
	},
	semantic_calendar: {
		days: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
		months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
		monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
		today: 'Heute',
		now: 'Jetzt',
		am: 'AM',
		pm: 'PM',
	},
	semantic_form: {
		text: {
			unspecifiedRule: 'Bitte geben Sie einen gültigen Wert ein',
			unspecifiedField: 'Dieses Feld'
		},
		prompt: {
			empty: '{name} darf nicht leer sein',
			checked: '{name} muss ausgewählt sein',
			email: '{name} muss eine gültige E-Mail-Adresse sein',
			url: '{name} muss eine gültige URL sein',
			regExp: '{name} hat nicht das richtige Format',
			integer: '{name} muss eine ganze Zahl sein',
			decimal: '{name} muss eine Dezimalzahl sein',
			number: '{name} muss eine Zahl sein',
			is: '{name} muss gleich \'{ruleValue}\' sein',
			isExactly: '{name} muss exakt \'{ruleValue}\' sein',
			not: '{name} darf nicht \'{ruleValue}\' sein',
			notExactly: '{name} darf nicht exakt \'{ruleValue}\' sein',
			contain: '{name} darf \'{ruleValue}\' nicht enthalten',
			containExactly: '{name} darf nicht genau \'{ruleValue}\' enthalten',
			doesntContain: '{name} muss \'{ruleValue}\' enthalten',
			doesntContainExactly: '{name} muss genau \'{ruleValue}\' enthalten',
			minLength: '{name} muss mindestens {ruleValue} Zeichen enthalten',
			length: '{name} muss mindestens {ruleValue} Zeichen lang sein',
			exactLength: '{name} muss genau {ruleValue} Zeichen lang sein',
			maxLength: '{name} darf nicht mehr als {ruleValue} Zeichen enthalten',
			match: '{name} muss mit dem Feld {ruleValue} übereinstimmen',
			different: '{name} muss sich vom Feld {ruleValue} unterscheiden',
			creditCard: '{name} muss eine gültige Kreditkartennummer sein',
			minCount: '{name} muss mindestens {ruleValue} Optionen enthalten',
			exactCount: '{name} muss genau {ruleValue} Optionen enthalten',
			maxCount: '{name} darf höchstens {ruleValue} Optionen enthalten'
		}
	},
	semantic_search: {
		error: {
			logging: "Fehler beim Debug-Logging. Beenden.",
			maxResults: "Ergebnisse müssen ein Array sein, um maxResults verwenden zu können",
			method: "Die aufgerufene Methode ist nicht definiert.",
			noEndpoint: "Kein Such-Endpunkt angegeben",
			noNormalize: "Die Option \"ignoreDiacritics\" wird ignoriert. String().normalize() wird von diesem Browser nicht unterstützt. Verwenden Sie <https://cdn.jsdelivr.net/npm/unorm@1.4.1/lib/unorm.min.js> als Polyfill.",
			noResults: "Ihre Suche ergab keine Ergebnisse",
			noResultsHeader: "Keine Ergebnisse",
			noTemplate: "Kein gültiger Vorlagenname angegeben.",
			oldSearchSyntax: "searchFullText wurde in fullTextSearch umbenannt. Bitte aktualisieren Sie Ihre Konfiguration.",
			serverError: "Ein Fehler beim Serverabruf ist aufgetreten.",
			source: "Suche nicht möglich. Keine Quelle angegeben und kein API-Modul eingebunden.",
		},
	},
	datatables: {
		lang: {
			"decimal": ",",
			"emptyTable": "Keine Daten verfügbar",
			"info": "Zeige _START_ bis _END_ von _TOTAL_ Einträgen",
			"infoEmpty": "Zeige 0 bis 0 von 0 Einträgen",
			"infoFiltered": "(gefiltert von _MAX_ Einträgen)",
			"infoPostFix": "",
			"thousands": ".",
			"lengthMenu": "_MENU_ Einträge anzeigen",
			"loadingRecords": "Lade...",
			"processing": "Verarbeite...",
			"search": "",
			"searchPlaceholder": "Suchen...",
			"zeroRecords": "Keine passenden Einträge gefunden",
			"paginate": {
				"first": "Erste",
				"last": "Letzte",
				"next": "Nächste",
				"previous": "Vorherige"
			},
			"aria": {
				"sortAscending": ": aktivieren für aufsteigende Sortierung",
				"sortDescending": ": aktivieren für absteigende Sortierung"
			}
		}
	},
	date: {
		days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
		daysLetter: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
		months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
		monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
		today: 'Heute',
		now: 'Jetzt',
		am: 'AM',
		pm: 'PM',
	},
	messenger: {
		'Error': 'Fehler',
		'Ha ocurrido un error desconocido.': 'Ein unbekannter Fehler ist aufgetreten.',
		'¡Listo!': 'Bereit!',
	},
	loginForm: {
		'Error': 'Fehler',
		'Ha ocurrido un error inesperado, intente más tarde.': 'Ein unerwarteter Fehler ist aufgetreten, bitte versuchen Sie es später erneut.',
		'Si continua con problemas para ingresar, por favor utilice la ayuda.': 'Wenn Sie weiterhin Probleme beim Einloggen haben, verwenden Sie bitte die Hilfe.',
		'Por favor, verifique los datos de ingreso y vuelva a intentar.': 'Bitte überprüfen Sie die Anmeldedaten und versuchen Sie es erneut.',
		'Por favor, ingrese al siguiente enlace para desbloquear su usuario.': 'Bitte gehen Sie zu folgendem Link, um Ihren Benutzer zu entsperren.',
		'Se ha presentado un error al momento de ingresar, por favor intente nuevamente.': 'Beim Einloggen ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.',
		'CONTRASEÑA_INVÁLIDA': '<span class="mark">Ungültig</span> <span class="text">Passwort</span>',
		'USUARIO_BLOQUEADO': '<span class="text">Benutzer</span> <span class="mark">gesperrt</span>',
		'USUARIO_INEXISTENTE': '<span class="text">Der Benutzer</span> <span class="mark">%r</span> <span class="text">existiert nicht</span>',
		'ERROR_AL_INGRESAR': 'Anmeldung fehlgeschlagen',
	},
	userProblems: {
		'Será solucionada muy pronto, por favor verifique su correo en las próximas horas. <br> El correo puede estar en "No deseado", por favor revise la carpeta de Spam. El remitente del correo es <strong>%r</strong>.': 'Es wird sehr bald gelöst, bitte überprüfen Sie Ihre E-Mails in den nächsten Stunden. <br> Die E-Mail könnte im "Spam" sein, bitte überprüfen Sie den Spam-Ordner. Der Absender der E-Mail ist <strong>%r</strong>.',
		'Ingrese el código enviado a su correo, el correo puede estar en "No deseado", por favor revise la carpeta de Spam. El remitente del correo es <strong>%r</strong>.': 'Geben Sie den Code ein, der an Ihre E-Mail gesendet wurde, die E-Mail könnte im "Spam" sein, bitte überprüfen Sie den Spam-Ordner. Der Absender der E-Mail ist <strong>%r</strong>.',
		'El correo ingresado no está asociado a ningún usuario, por favor ingrese otra cuenta de correo o puede crear una solicitud de soporte para asociar ese correo a su cuenta.': 'Die eingegebene E-Mail ist keinem Benutzer zugeordnet, bitte geben Sie ein anderes E-Mail-Konto ein oder erstellen Sie eine Supportanfrage, um diese E-Mail mit Ihrem Konto zu verknüpfen.',
		'El código ingresado está errado, por favor vuelva a ingresar el código, solicite uno nuevo o cree una solicitud de soporte para informar del error.': 'Der eingegebene Code ist falsch, bitte geben Sie den Code erneut ein, fordern Sie einen neuen an oder erstellen Sie eine Supportanfrage, um den Fehler zu melden.',
		'Ingrese con su usuario y la nueva contraseña': 'Melden Sie sich mit Ihrem Benutzernamen und dem neuen Passwort an',
		'Las contraseñas no coinciden': 'Die Passwörter stimmen nicht überein',
	},
	avatar: {
		'Confirmación': 'Bestätigung',
		'¿Seguro de guardar el avatar?': 'Sind Sie sicher, dass Sie das Avatar speichern möchten?',
		'Cargando...': 'Laden...',
		'¿Seguro de guardar la foto de perfil?': 'Sind Sie sicher, dass Sie das Profilbild speichern möchten?',
		'Sí': 'Ja',
		'No': 'Nein',
	},
	public: {
		'Ver más': 'Mehr lesen',
	}
}
